// packages/shared/src/credit/zod.ts
//
// Credit request Zod schemas — Phase 3.4b.
//
// Node-pure (no Fastify / Mongoose). Safe to bundle in Vite client builds.
//
// Schema ↔ contract route mapping (see API-CONTRACTS.md):
//   - createCreditSchema  → POST  /admin/.../credit          (PostAdminCreditRequest)
//   - updateCreditSchema  → PATCH /admin/.../credit/:id      (PatchAdminCreditRequest)
//   - payCreditSchema     → POST  /billing/credit/pay        (PostBillingCreditPayRequest)
//   - useCreditSchema     → POST  /internal/credit/use       (PostInternalCreditUseRequest)
//   - revokeCreditSchema  → POST  /admin/.../credit/:id/revoke (PostRevokeCreditRequest)
import { z } from 'zod';
import { ObjectIdHex, IsoDateTime, PositiveCents, CreditOptions } from './types.js';
// createCreditSchema = POST /admin/.../credit body (PostAdminCreditRequest)
export const createCreditSchema = z.object({
    description: z.string().max(500).optional(),
    limitCents: PositiveCents,
    periodDays: z.number().int().min(1).max(3650),
    startDate: IsoDateTime,
    options: CreditOptions,
}).strict();
// updateCreditSchema = PATCH (PatchAdminCreditRequest)
export const updateCreditSchema = z.object({
    limitCents: PositiveCents.optional(),
    periodDays: z.number().int().min(1).max(3650).optional(),
    options: CreditOptions.partial().optional(),
}).strict().refine((v) => v.limitCents !== undefined || v.periodDays !== undefined || v.options !== undefined, { message: 'At least one of limitCents, periodDays, or options must be provided' });
// payCreditSchema = POST /billing/credit/pay body (PostBillingCreditPayRequest)
export const payCreditSchema = z.object({
    amountCents: z.number().int().min(100, 'Minimum $1 (100 cents)'),
}).strict();
// useCreditSchema = POST /internal/credit/use body (PostInternalCreditUseRequest)
// CreditUseRefType is a 3-element enum: order, surcharge, embroidery
export const CreditUseRefType = z.enum(['order', 'surcharge', 'embroidery']);
export const useCreditSchema = z.object({
    merchantId: ObjectIdHex,
    amountCents: PositiveCents,
    refType: CreditUseRefType,
    refId: ObjectIdHex,
    idempotencyKey: z.string().min(8).max(128).optional(),
}).strict();
// revokeCreditSchema = POST /admin/.../revoke body (PostRevokeCreditRequest)
export const revokeCreditSchema = z.object({
    reason: z.string().trim().min(10, 'Reason must be at least 10 characters').max(500),
}).strict();
//# sourceMappingURL=zod.js.map